import ApiService from '@/services/api.service.js';

export const ClarificationService = {

  question: function (data) {
    return ApiService.post('/clarification-question', data);
  },

  answer: function (data) {
    return ApiService.post('/clarification-answer', data);
  },

  all: function () {
    return ApiService.get('/clarifications');
  },

  get: function (applicationId) {
    return ApiService.get('/clarification-get/' + applicationId);
  }
}

export default ClarificationService